import React from 'react';
import { motion } from 'framer-motion';
import './Home.css'; // Import the CSS

function Home() {
  return (
    <motion.div
      className="home-container"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Hero Section
      <section className="hero">
        <h2>Welcome to ProMaster</h2>
        <p>Your trusted partner for quality services.</p>
      </section> */}
      <section className="hero-video">
  <video autoPlay loop muted playsInline className="background-video">
    <source src="promaster.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
  <div className="overlay-content">
    <h2>Welcome to ProMaster</h2>
    <p>Your trusted partner for quality services.</p>
    <button className="explore-btn">Explore</button>
  </div>
</section>


      {/* Services Section
      <section className="services">
        <h3>Our Services</h3>
        <div className="card-grid">
          {[
            { emoji: '📊', title: 'Data Mining' },
            { emoji: '📣', title: 'Digital Marketing' },
            { emoji: '🛡️', title: 'Security Consulting' },
            { emoji: '💻', title: 'Cyber Security' },
          ].map((service, idx) => (
            <div key={idx} className="service-card">
              <div className="emoji">{service.emoji}</div>
              <h4>{service.title}</h4>
            </div>
          ))}
        </div>
      </section> */}
      {/* Services Section */}
<section className="services">
  <h3 className="section-title">OUR SERVICES</h3>
  <div className="card-grid">
    {[
      {
        icon: '📊',
        title: 'Data Mining',
        desc: 'Analyze, process, and extract insights from large datasets efficiently.',
      },
      {
        icon: '📣',
        title: 'Digital marketing',
        desc: 'Ensure compliance, fraud detection, and financial insights for banking data.',
      },
      // {
      //   icon: '💻',
      //   title: 'Cyber Security',
      //   desc: 'Analyze call data to gain customer insights and operational efficiency.',
      // },
      {
        icon: '🛡️',
        title: 'Security Consulting',
        desc: 'Protect systems and networks from digital attacks and vulnerabilities.',
      },
    ].map((service, idx) => (
      <div key={idx} className="service-card">
        <div className="emoji">{service.icon}</div>
        <h4>{service.title}</h4>
        <p>{service.desc}</p>
        <a href="#" className="learn-more">Learn More →</a>
      </div>
    ))}
  </div>
</section>


      {/* Contact Us Section */}
      <section className="contact">
        <h3>Contact Us</h3>
        <form
        className="contact-form"
       action="https://formsubmit.co/promaster.consulting@gmail.com"
  method="POST"
>
  <input type="text" name="name" placeholder="Name" required />
  <input type="email" name="email" placeholder="Email" required />
  <input type="tel" name="mobile" placeholder="Mobile No." required />
  <textarea name="message" placeholder="Your Message" rows="4" required></textarea>

  {/* Optional hidden inputs
  <input type="hidden" name="_captcha" value="false" />
  <input type="hidden" name="_next" value="https://yourwebsite.com/thankyou" /> */}

  <button type="submit">Send Message</button>
</form>

      </section>
    </motion.div>
  );
}

export default Home;
